// src/components/HeroSection.js
import React, { useEffect, useRef, useState } from "react";
import "animate.css";

import img from "../../assets/img/hero-regent.webp";

const HeroSection = ({ scrollToConsult }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false); // Set to false when the section is not visible
          }
        });
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      className="container-fluid"
      style={{
        backgroundColor: "#F9F6F0",
      }}
    >
      <div
        className="row align-items-center px-5"
        style={{ marginTop: "65px" }}
        ref={sectionRef}
      >
        <div className="col-lg-6">
          <img
            src={img}
            className={`img-fluid rounded-5 w-100 p-4 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
            alt="hero"
          />
        </div>

        <div className="col-lg-6 px-lg-4 mb-3 mt-4">
          <h1
            className={`text-dark fs-48 mt-5 mt-lg-0 fw-800 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            Seamless, Natural-Looking Smiles with{" "}
            <span className="text-golden"> Composite Bonding! </span>
          </h1>
          <p
            className={`fs-17 fw-400 text-dark ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            Start Your <span className="text-golden">Smile</span> Transformation
            with a FREE Composite Bonding Consultation!
          </p>
          <ul
            className={`list-unstyled ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">10% </span>Off Your Composite
                Bonding Treatment 
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Smile Assessment
                (worth £75)
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Digital Smile Preview
                (worth £250)
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Electric Toothbrush
                (worth £60)
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-17 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>
                <span className="text-golden">FREE</span> Teeth Whitening (worth
                £295)
              </p>{" "}
            </li>
          </ul>
          <a
            className={`btn btn-theme fs-14 mb-4 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
            onClick={scrollToConsult}
          >
            BOOK A FREE CONSULTATION
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
